// import moment from 'moment'

export function clearObject(payload) {
  delete payload.__v
  delete payload.createdBy
  delete payload.createdAt
  delete payload.updated
  delete payload.profile
}
export function parseObject(payload) {
  let result = {}
  Object.keys(payload).forEach((key) => {
    if (payload[key] === null || payload[key] === undefined) return
    if (Array.isArray(payload[key])) {
      let items = []
      if (
        payload[key].length &&
        typeof payload[key][0] === 'object' &&
        key !== 'name' &&
        key !== 'description'
      ) {
        payload[key].forEach((item) => items.push(item._id || item.id))
      } else payload[key].forEach((item) => items.push(item))
      result[key] = items
    } else if (typeof payload[key] === 'object') {
      result[key] = payload[key]._id || payload[key].id
    } else result[key] = payload[key]
  })
  clearObject(result)
  return result
}
export function parseFilters(state, params = {}, filters = {}) {
  let query = {
    page: state.pagination.page,
    limit: state.pagination.rowsPerPage,
  }
  let body = Object.assign({}, params, filters)
  if (body.limit !== undefined) {
    query.limit = body.limit
    delete body.limit
  }
  if (body.page) {
    query.page = body.page
    delete body.page
  }
  if (state.filters) {
    Object.keys(state.filters).forEach((key) => {
      if (
        state.filters[key] !== '' &&
        state.filters[key] !== undefined &&
        state.filters[key] !== null
      ) {
        body[key] = state.filters[key]
      }
    })
  }
  if (state.pagination.sortBy) {
    query.sort = {
      [state.pagination.sortBy]: state.pagination.descending ? -1 : 1,
    }
  }
  if (state.selected && state.selected.active !== undefined) body.active = 'all'

  return { body, query }
}
export function parseSliderFilters(
  filters,
  pagination,
  params = {},
  roleFilters = {}
) {
  let query = {
    page: pagination.page,
    limit: pagination.rowsPerPage,
  }
  let body = {}
  Object.keys(params).forEach((key) => {
    if (
      params[key] !== '' &&
      params[key] !== undefined &&
      params[key] !== null
    ) {
      body[key] = params[key]
    }
  })
  Object.keys(filters).forEach((key) => {
    if (
      filters[key] !== '' &&
      filters[key] !== undefined &&
      filters[key] !== null
    ) {
      body[key] = filters[key]
    }
  })

  if (body.limit !== undefined) {
    query.limit = body.limit
    delete body.limit
  }
  if (body.page) {
    query.page = body.page
    delete body.page
  }
  if (roleFilters) {
    Object.keys(roleFilters).forEach((key) => {
      if (
        roleFilters[key] !== '' &&
        roleFilters[key] !== undefined &&
        roleFilters[key] !== null
      ) {
        body[key] = roleFilters[key]
      }
    })
  }
  if (pagination.sortBy) {
    query.sort = {
      [pagination.sortBy]: pagination.descending ? -1 : 1,
    }
  }
  return { body, query }
}
export function filterArray(array, text) {
  if (!text) return array
  let auxArray = []
  let regex = new RegExp(`${text}.*`, 'i')

  for (let i in array) {
    let temp = false
    for (let j in array[i]) {
      if (
        array[i][j] &&
        !Array.isArray(array[i][j]) &&
        regex.test(array[i][j].toString()) &&
        !temp
      ) {
        auxArray.push(array[i])
        temp = true
      }
    }
  }
  return auxArray
}

export function camel(str) {
  const camel = (str || '').replace(/-([^-])/g, (g) => g[1].toUpperCase())

  return capitalize(camel)
}

export function camelActual(str) {
  return (str || '').replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''))
}

/* export function kebab (str) {
   return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
 } */
export function capitalize(str) {
  str = str || ''
  return `${str.substr(0, 1).toUpperCase()}${str.slice(1)}`
}

const randomElement = (arr = []) => {
  return arr[Math.floor(Math.random() * arr.length)]
}

const kebab = (str) => {
  return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
}

const toggleFullScreen = () => {
  let doc = window.document
  let docEl = doc.documentElement

  let requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.msRequestFullscreen
  let cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen

  if (
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement
  ) {
    requestFullScreen.call(docEl)
  } else {
    cancelFullScreen.call(doc)
  }
}
export const rangexy = (start, end) =>
  Array.from({ length: end - start }, (v, k) => k + start)

export default {
  randomElement,
  toggleFullScreen,
  kebab,
  camel,
  camelActual,
  capitalize,
}
